import { isInvestCompany } from "helpers/Others/company_helper";
import { getAppConfig } from "config/configInitializer";
import { useEffect, useState } from "react";

export const RTL_LANGUAGES = ["ar", "ar-SA", "ar-AE", "ar-AR", "ur", "ur-PK"];

const languages = [
  {
    $id: "1",
    id: 1,
    languageCode: "en-US",
    culture: "en-US",
    languageTitle: "English",
  },
  {
    $id: "2",
    id: 2,
    languageCode: "zh-CN",
    culture: "zh-CN",
    languageTitle: "Chinese",
  },
  {
    $id: "3",
    id: 3,
    languageCode: "TW",
    culture: "zh-TW",
    languageTitle: "Taiwanese",
  },
  {
    $id: "4",
    id: 4,
    languageCode: "HI",
    culture: "hi-IN",
    languageTitle: "Hindi",
  },
  {
    $id: "5",
    id: 5,
    languageCode: "th",
    culture: "th-TH",
    languageTitle: "Thai",
  },
  {
    $id: "6",
    id: 6,
    languageCode: "vi-VN",
    culture: "vi-VN",
    languageTitle: "Vietnamese",
  },
  {
    $id: "7",
    id: 7,
    languageCode: "KR",
    culture: "ko-KR",
    languageTitle: "Korean",
  },
  {
    $id: "8",
    id: 8,
    languageCode: "tl-PH",
    culture: "en-PH",
    languageTitle: "Filipino",
  },
  {
    $id: "9",
    id: 9,
    languageCode: "es-ES",
    culture: "es-ES",
    languageTitle: "Spanish",
  },
  {
    $id: "10",
    id: 10,
    languageCode: "ja-JP",
    culture: "ja-JP",
    languageTitle: "Japanese",
  },
  // {
  //   $id: "11",
  //   id: 11,
  //   languageCode: "ur-PK",
  //   culture: "ur-PK",
  //   languageTitle: "Pakistan",
  // },
  {
    $id: "12",
    id: 12,
    languageCode: "ar-AE",
    culture: "ar-AE",
    languageTitle: "Arabic",
  },
  {
    $id: "13",
    id: 13,
    languageCode: "id-IN",
    culture: "id-IN",
    languageTitle: "Indonesian",
  },
];

export const useFilteredLanguages = () => {
  const [filteredLanguages, setFilteredLanguages] = useState<typeof languages>(
    [],
  );
  const INDONESIAN_LANGUAGE_CODE = "id-IN";
  const ENGLISH_LANGUAGE_CODE = "en-US";

  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase();

    const isInvestProd = hostname === "partner.triveinvest.co.id";

    const isInvestTestOrStaging =
      hostname === "partnertest.triveinvest.co.id" ||
      hostname === "partner-staging.triveinvest.co.id";

    let allowedLanguageCodes: string[];

    if (isInvestProd) {
      allowedLanguageCodes = [INDONESIAN_LANGUAGE_CODE];
    } else if (isInvestTestOrStaging) {
      allowedLanguageCodes = [INDONESIAN_LANGUAGE_CODE, ENGLISH_LANGUAGE_CODE];
    } else {
      allowedLanguageCodes = languages
        .map((lang) => lang.languageCode)
        .filter((code) => code !== INDONESIAN_LANGUAGE_CODE);
    }
    console.log(allowedLanguageCodes);
    const filtered = languages.filter((lang) =>
      allowedLanguageCodes.includes(lang.languageCode),
    );
    console.log(filtered);

    setFilteredLanguages(filtered);
  }, []);

  return filteredLanguages;
};
